export default {
  primitive: {
    red: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
    },
    sky: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9',
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
      950: '#082f49',
    },
    blue: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
      950: '#172554',
    },
    cyan: {
      50: '#ecfeff',
      100: '#cffafe',
      200: '#a5f3fc',
      300: '#67e8f9',
      400: '#22d3ee',
      500: '#06b6d4',
      600: '#0891b2',
      700: '#0e7490',
      800: '#155e75',
      900: '#164e63',
      950: '#083344',
    },
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      950: '#030712',
    },
    lime: {
      50: '#f7fee7',
      100: '#ecfccb',
      200: '#d9f99d',
      300: '#bef264',
      400: '#a3e635',
      500: '#84cc16',
      600: '#65a30d',
      700: '#4d7c0f',
      800: '#3f6212',
      900: '#365314',
      950: '#1a2e05',
    },
    pink: {
      50: '#fdf2f8',
      100: '#fce7f3',
      200: '#fbcfe8',
      300: '#f9a8d4',
      400: '#f472b6',
      500: '#ec4899',
      600: '#db2777',
      700: '#be185d',
      800: '#9d174d',
      900: '#831843',
      950: '#500724',
    },
    rose: {
      50: '#fff1f2',
      100: '#ffe4e6',
      200: '#fecdd3',
      300: '#fda4af',
      400: '#fb7185',
      500: '#f43f5e',
      600: '#e11d48',
      700: '#be123c',
      800: '#9f1239',
      900: '#881337',
      950: '#4c0519',
    },
    teal: {
      50: '#f0fdfa',
      100: '#ccfbf1',
      200: '#99f6e4',
      300: '#5eead4',
      400: '#2dd4bf',
      500: '#14b8a6',
      600: '#0d9488',
      700: '#0f766e',
      800: '#115e59',
      900: '#134e4a',
      950: '#042f2e',
    },
    zinc: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b',
    },
    amber: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
    green: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      950: '#052e16',
    },
    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    stone: {
      50: '#fafaf9',
      100: '#f5f5f4',
      200: '#e7e5e4',
      300: '#d6d3d1',
      400: '#a8a29e',
      500: '#78716c',
      600: '#57534e',
      700: '#44403c',
      800: '#292524',
      900: '#1c1917',
      950: '#0c0a09',
    },
    indigo: {
      50: '#eef2ff',
      100: '#e0e7ff',
      200: '#c7d2fe',
      300: '#a5b4fc',
      400: '#818cf8',
      500: '#6366f1',
      600: '#4f46e5',
      700: '#4338ca',
      800: '#3730a3',
      900: '#312e81',
      950: '#1e1b4b',
    },
    orange: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#f97316',
      600: '#ea580c',
      700: '#c2410c',
      800: '#9a3412',
      900: '#7c2d12',
      950: '#431407',
    },
    purple: {
      50: '#faf5ff',
      100: '#f3e8ff',
      200: '#e9d5ff',
      300: '#d8b4fe',
      400: '#c084fc',
      500: '#a855f7',
      600: '#9333ea',
      700: '#7e22ce',
      800: '#6b21a8',
      900: '#581c87',
      950: '#3b0764',
    },
    violet: {
      50: '#f5f3ff',
      100: '#ede9fe',
      200: '#ddd6fe',
      300: '#c4b5fd',
      400: '#a78bfa',
      500: '#8b5cf6',
      600: '#7c3aed',
      700: '#6d28d9',
      800: '#5b21b6',
      900: '#4c1d95',
      950: '#2e1065',
    },
    yellow: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
      950: '#422006',
    },
    emerald: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#10b981',
      600: '#059669',
      700: '#047857',
      800: '#065f46',
      900: '#064e3b',
      950: '#022c22',
    },
    fuchsia: {
      50: '#fdf4ff',
      100: '#fae8ff',
      200: '#f5d0fe',
      300: '#f0abfc',
      400: '#e879f9',
      500: '#d946ef',
      600: '#c026d3',
      700: '#a21caf',
      800: '#86198f',
      900: '#701a75',
      950: '#4a044e',
    },
    neutral: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
      950: '#0a0a0a',
    },
    borderRadius: {
      lg: '8px',
      md: '6px',
      sm: '4px',
      xl: '12px',
      xs: '2px',
      none: '0',
    },
  },
  semantic: {
    list: {
      gap: '0',
      header: {
        padding: '0.625rem 1rem 0 1rem',
      },
      option: {
        padding: '0.625rem 1rem',
        borderRadius: '0',
      },
      padding: '0.5rem 0',
      optionGroup: {
        padding: '0.625rem 1rem',
        fontWeight: '600',
      },
    },
    mask: {
      transitionDuration: '0.3s',
    },
    content: {
      borderRadius: '{border.radius.md}',
    },
    overlay: {
      modal: {
        shadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
        padding: '0.75rem',
        borderRadius: '{border.radius.xl}',
      },
      select: {
        shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
        borderRadius: '{border.radius.md}',
      },
      popover: {
        shadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        padding: '1rem',
        borderRadius: '{border.radius.md}',
      },
      navigation: {
        shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
      },
    },
    primary: {
      50: '{nash.purple.50}',
      100: '{nash.purple.100}',
      200: '{nash.purple.200}',
      300: '{nash.purple.300}',
      400: '{nash.purple.400}',
      500: '{nash.purple.500}',
      600: '{nash.purple.600}',
      700: '{nash.purple.600}',
      800: '{nash.neutral.800}',
      900: '{nash.neutral.900}',
      950: '{nash.neutral.900}',
    },
    iconSize: '{nash.sizing.space.space-100}',
    focusRing: {
      color: '{primary.600}',
      style: 'none',
      width: '0',
      offset: '0',
    },
    formField: {
      lg: {
        fontSize: '1.125rem',
        paddingX: '0.875rem',
        paddingY: '0.75rem',
      },
      sm: {
        fontSize: '0.875rem',
        paddingX: '0.625rem',
        paddingY: '0.5rem',
      },
      paddingX: '0.75rem',
      paddingY: '0.625rem',
      focusRing: {
        color: 'transparent',
        style: 'none',
        width: '0',
        offset: '0',
        shadow: 'none',
      },
      borderRadius: '{border.radius.md}',
      transitionDuration: '{transition.duration}',
    },
    navigation: {
      item: {
        gap: '0.5rem',
        padding: '0.625rem 1rem',
        borderRadius: '0',
      },
      list: {
        gap: '0',
        padding: '0.5rem 0',
      },
      submenuIcon: {
        size: '0.875rem',
      },
      submenuLabel: {
        padding: '0.625rem 1rem',
        fontWeight: '600',
      },
    },
    colorScheme: {
      dark: {
        list: {
          option: {
            icon: {
              color: '{surface.500}',
              focusColor: '{surface.400}',
            },
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            focusBackground: '{surface.800}',
            selectedBackground: '{highlight.background}',
            selectedFocusColor: '{highlight.focus.color}',
            selectedFocusBackground: '{highlight.focus.background}',
          },
          optionGroup: {
            color: '{text.color}',
            background: 'transparent',
          },
        },
        mask: {
          color: '{surface.200}',
          background: 'rgba(0,0,0,0.6)',
        },
        text: {
          color: '{surface.0}',
          hoverColor: '{surface.0}',
          mutedColor: '{surface.400}',
          hoverMutedColor: '{surface.300}',
        },
        content: {
          color: '{text.color}',
          background: '{surface.900}',
          hoverColor: '{text.hover.color}',
          borderColor: '{surface.700}',
          hoverBackground: '{surface.800}',
        },
        overlay: {
          modal: {
            color: '{text.color}',
            background: '{surface.900}',
            borderColor: '{surface.700}',
          },
          select: {
            color: '{text.color}',
            background: '{surface.900}',
            borderColor: '{surface.700}',
          },
          popover: {
            color: '{text.color}',
            background: '{surface.900}',
            borderColor: '{surface.700}',
          },
        },
        primary: {
          color: '{primary.400}',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
          contrastColor: '{surface.900}',
        },
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}',
        },
        focusRing: {
          shadow:
            '0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%)',
        },
        formField: {
          color: '{surface.0}',
          shadow: 'none',
          iconColor: '{surface.400}',
          background: '{surface.950}',
          borderColor: '{surface.600}',
          disabledColor: '{surface.400}',
          floatLabelColor: '{surface.400}',
          filledBackground: '{surface.800}',
          focusBorderColor: '{primary.color}',
          hoverBorderColor: '{primary.color}',
          placeholderColor: '{surface.400}',
          disabledBackground: '{surface.700}',
          invalidBorderColor: '{red.300}',
          floatLabelFocusColor: '{primary.color}',
          filledFocusBackground: '{surface.950}',
          filledHoverBackground: '{surface.800}',
          floatLabelActiveColor: '{surface.400}',
          floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
          invalidPlaceholderColor: '{red.400}',
        },
        highlight: {
          color: 'rgba(255,255,255,.87)',
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusColor: 'rgba(255,255,255,.87)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
        },
        navigation: {
          item: {
            icon: {
              color: '{surface.500}',
              focusColor: '{surface.400}',
              activeColor: '{surface.400}',
            },
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            focusBackground: '{surface.800}',
            activeBackground: '{surface.800}',
          },
          submenuIcon: {
            color: '{surface.500}',
            focusColor: '{surface.400}',
            activeColor: '{surface.400}',
          },
          submenuLabel: {
            color: '{text.color}',
            background: 'transparent',
          },
        },
      },
      light: {
        list: {
          option: {
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}',
            },
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            focusBackground: '{primary.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusColor: '{highlight.color}',
            selectedFocusBackground: '{highlight.background}',
          },
          optionGroup: {
            color: '{text.color}',
            background: 'transparent',
          },
        },
        mask: {
          color: '{surface.200}',
          background: 'rgba(0,0,0,0.4)',
        },
        text: {
          color: '{surface.700}',
          hoverColor: '{nash.neutral.800}',
          mutedColor: '{surface.600}',
          hoverMutedColor: '{nash.purple.100}',
        },
        content: {
          color: '{text.color}',
          background: '{nash.wheat.50}',
          hoverColor: '{tprimary.000}',
          borderColor: '{surface.200}',
          hoverBackground: '{primary.100}',
        },
        overlay: {
          modal: {
            color: '{text.color}',
            background: '{surface.0}',
            borderColor: '{surface.200}',
          },
          select: {
            color: '{text.color}',
            background: '{surface.0}',
            borderColor: '{surface.200}',
          },
          popover: {
            color: '{text.color}',
            background: '{surface.0}',
            borderColor: '{surface.200}',
          },
        },
        primary: {
          color: '{primary.500}',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
          contrastColor: '{nash.neutral.000}',
        },
        surface: {
          0: '{nash.neutral.000}',
          50: '{nash.neutral.100}',
          100: '{nash.neutral.100}',
          200: '{nash.neutral.200}',
          300: '{nash.neutral.300}',
          400: '{nash.neutral.400}',
          500: '{nash.neutral.500}',
          600: '{nash.neutral.600}',
          700: '{nash.neutral.700}',
          800: '{nash.neutral.800}',
          900: '{nash.neutral.900}',
          950: '{nash.neutral.900}',
        },
        focusRing: {
          shadow: '0 0 0 0.2rem {primary.200}',
        },
        formField: {
          color: '{surface.800}',
          shadow:
            'none0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)',
          iconColor: '{surface.600}',
          background: '{surface.0}',
          borderColor: '{surface.300}',
          disabledColor: '{surface.500}',
          floatLabelColor: '{surface.500}',
          filledBackground: '{surface.50}',
          focusBorderColor: '{primary.color}',
          hoverBorderColor: '{surface.400}',
          placeholderColor: '{surface.700}',
          disabledBackground: '{surface.200}',
          invalidBorderColor: '{nash.tigerlily.800}',
          floatLabelFocusColor: '{primary.600}',
          filledFocusBackground: '{surface.50}',
          filledHoverBackground: '{surface.50}',
          floatLabelActiveColor: '{surface.500}',
          floatLabelInvalidColor: '{nash.tigerlily.800}',
          invalidPlaceholderColor: '{nash.tigerlily.800}',
        },
        highlight: {
          color: '{primary.700}',
          background: '{primary.200}',
          focusColor: '{surface.0}',
          focusBackground: '{nash.purple.500}',
        },
        navigation: {
          item: {
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}',
              activeColor: '{surface.500}',
            },
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            focusBackground: '{surface.100}',
            activeBackground: '{surface.100}',
          },
          submenuIcon: {
            color: '{surface.400}',
            focusColor: '{surface.500}',
            activeColor: '{surface.500}',
          },
          submenuLabel: {
            color: '{text.muted.color}',
            background: 'transparent',
          },
        },
      },
    },
    anchorGutter: '2px',
    disabledOpacity: '0.6',
    transitionDuration: '0.2s',
  },
}
